import styled from 'styled-components';
import Lora from '../../assets/customer-review-avatars/lora.png';
import Jordan from '../../assets/customer-review-avatars/jordan.png';
import Brandy from '../../assets/customer-review-avatars/brandy.png';
import Rita from '../../assets/customer-review-avatars/rita.png';
import Jessica from '../../assets/customer-review-avatars/jessica.png';
import Jie from '../../assets/customer-review-avatars/jie.png';
import StarsIcon from '../../assets/stars.png';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

const customerReviews = [
  {
    text: "Setup was so easy and just took a couple of minutes.  I am sitting laughing because it is so funny seeing my puppies bewildered look when I'm talking to him.",
    avatar: Rita,
    name: '- Rita',
  },
  {
    text: '“It is very easy to setup. I just plugged it, downloaded the APP, and connected the WiFi. And then, guess what? It showed me the view with high-definition picture! And my boy can call me just to touch the Call button. That is easy!”',
    avatar: Jie,
    name: '- Jie',
  },
  {
    text: "The packaging was very secure, and the price is incredibly affordable. Unlike other cameras that require expensive subscription plans, this one doesn't — and it even comes with a free SD card!  It's a great deal.",
    avatar: Jessica,
    name: '- Jessica',
  },
  {
    text: "I loved the packaging. Love that you're committed to not have a camera fully dependent on a subscription plan.",
    avatar: Lora,
    name: '- Lora M.',
  },
  {
    text: '“Awesome!!! Loving this thing so far!!”',
    avatar: Jordan,
    name: '- Jordan B.',
  },
  {
    text: '“Some of my favorites is watching my cats play ! They seem to set it off constantly 😆💕 they are so funny to watch!”',
    avatar: Brandy,
    name: '- Brandy',
  }
];

// Styled Components
const Section = styled.div`
  background-color: #faf5f3;
  padding: 1rem 1.5rem 3rem;
  @media (min-width: 768px) {
    padding: 2rem 5rem 5rem;
  }
`;

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #b45309;
`;

const Subtitle = styled.p`
  color: #374151;
  margin-bottom: 2rem;
`;

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: #f1eae5;
  padding: 32px 28px 32px 28px;
  border-radius: 1.5rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  min-height: 450px;
  max-height: 450px;
  width: 370px;
  max-width: 370px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
  @media (max-width: 767px) {
    margin: 0 auto;
    width: 90vw;
    min-width: unset;
    max-width: unset;
    min-height: 320px;
    max-height: unset;
    padding: 24px 10px;
  }
`;

const Stars = styled.span`
  background: #fff;
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
  width: fit-content;
  align-self: flex-start;
`;

const ReviewText = styled.p`
  color: #374151;
  margin-bottom: 1.2rem;
  font-size: 1.1rem;
  font-weight: 400;
  text-align: left;
`;

const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-top: auto;
  width: 100%;
`;

const Avatar = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  margin-bottom: 0.5rem;
`;

const Name = styled.p`
  color: #374151;
  font-weight: 600;
  font-size: 1rem;
  margin: 0;
  text-align: left;
  width: 100%;
`;

export default function CustomerSay() {
  return (
    <Section>
      <Title>What our customers say about us</Title>
      <Subtitle>
        Don&apos;t just take our word for it. Here&apos;s how Sensforge cameras
        are making everyday life safer, simpler, and more connected for people
        like you.
      </Subtitle>
      <CarouselWrapper>
        <Splide
          options={{
            type: 'loop',
            gap: '1.2rem',
            perPage: 3,
            focus: 'center',
            trimSpace: false, // Prevent trimming space for true centering
            autoplay: true,
            interval: 5000,
            arrows: true,
            pagination: false,
            breakpoints: {
              1400: {
                perPage: 3,
                focus: 'center',
                trimSpace: false,
              },
              1024: {
                perPage: 2,
                focus: 'center',
                trimSpace: false,
              },
              767: {
                perPage: 1,
                width: '100%',
                focus: 'center',
                trimSpace: false,
              },
            },
          }}
        >
          {customerReviews.map((review, index) => (
            <SplideSlide key={index}>
              <Card>
                <Stars>
                  <img src={StarsIcon} alt="stars" />
                </Stars>
                <ReviewText>{review.text}</ReviewText>
                <AvatarWrapper>
                  <Avatar src={review.avatar} alt={review.name} />
                  <Name>{review.name}</Name>
                </AvatarWrapper>
              </Card>
            </SplideSlide>
          ))}
        </Splide>
      </CarouselWrapper>
    </Section>
  );
}